import { createRoute, redirect, useNavigate } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";
import { useAuth } from "@/hooks/useAuth";
import { useEffect } from "react";
import { getBackendToken } from "@/lib/tokenCache";
import { msalInstance } from "@/lib/msal/instance";

function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate({ to: "/dashboard" });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-8">
        <img src="/Centring_vertical.png" alt="Centring" className="h-28 object-contain" />
        <p className="text-muted-foreground">
          Learn Faster. Deliver Better.
        </p>
        <button
          onClick={login}
          className="rounded-lg bg-primary px-6 py-3 text-primary-foreground hover:opacity-90 transition-opacity"
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "login",
  beforeLoad: () => {
    // If already authenticated (token in localStorage or MSAL session),
    // skip login page entirely.
    if (getBackendToken() || msalInstance.getAllAccounts().length > 0) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: LoginPage,
});
